// Report.js
import React, { useMemo } from "react"
import {
  Document,
  Page,
  Text,
  View,
  StyleSheet,
} from "@react-pdf/renderer"
import { getBillType, getDateFn, getMemoParticular, getPktType, getTradeOf } from "./ReportUtility.js"
import { calculateTotal, calculateTotalWeight } from "../../Utility/utility.js"
import { useSelector } from "react-redux"
import { ENUM_CURRENCY_SETTING_VAL } from "../../constants/enum.js"


const border_color = "#2f2e2e"


// Create PDF component

const RptMemo = ({ rptdata, moddata, currencysetting, fsize, termsdata }) => {
  
  let t_termsCondition = ""
  if (termsdata && termsdata.length > 0) {
    t_termsCondition = termsdata[0]?.Terms || ""
  }
  const styles = StyleSheet.create({
    page: {
      flexDirection: 'row',
      backgroundColor: '#FFFFFF',
    },
    section: {
      fontFamily: 'Helvetica',
      margin: 10,
      padding: 0,
      flexGrow: 1,
      fontSize: "9px",
      borderColor: "#475569",
      borderWidth: "1px"
    },
    table: {
      display: 'table',
      width: '100%',
      borderStyle: 'solid',
      borderTopWidth: 0,
      borderRightWidth: 0,
      borderBottomWidth: 0
    },
    tableRow: {
      margin: 'auto',
      flexDirection: 'row',
      width: "100%"
    },
    tableColHeader: {
      borderStyle: 'solid',
      borderWidth: 1,
      borderLeftWidth: 1,
      borderTopWidth: 1,
      lineHeight: "1.5"
    },
    tableCol: {
      borderStyle: 'solid',
      borderTopWidth: 0,
      borderColor: border_color,
      padding: "2",
    },
    tableCell: {
      padding: 4,
    },
    colMid: {
      padding: "0px 3px 0px 3px"
    },
    srno: {
      width: "15%"
    },
    desc: {
      width: "50%"
    },
    pkt: {
      width: "10%"
    },
    pcs: {
      width: "20%"
    },
    weight: {
      width: "30%"
    },
    amount: {
      width: "40%"
    },
    rate: {
      width: "25%"
    },
    fontBold: {
      fontSize: "9px", fontFamily: 'Helvetica-Bold',
    },
    tableTopBorder: {
      borderTop: 1,
      borderColor: border_color,
    },
    tableHeading: {
      fontSize: "8px",
      textTransform: "uppercase",
      textAlign: "center",
      fontFamily: 'Helvetica-Bold',
      padding: "2px 0px 2px 0px"
    },
    Heading: {
      fontSize: "13px",
      textTransform: "uppercase",
      textAlign: "center",
      fontFamily: 'Helvetica-Bold',
    },
    tableItem: {
      padding: "2px 0px 2px 0px"
    },
    colWidth: {
      width: "80%",
      textAlign: "left",
    },
    colWidth_label: {
      width: "20%",
      fontFamily: 'Helvetica-Bold',
      fontSize: "9px"
    },
    footerText: {
      fontSize: "8px",
      fontWeight: 600,
      textTransform: "uppercase",
      fontFamily: 'Helvetica-Bold'
    },
    tblBorderLeft: {
      borderLeftWidth: 1
    },
    tblBorderRight: {
      borderRightWidth: 1
    },
    colBorder: {
      textAlign: "center",
      padding: "3px"
    },
    scaledContent: {
      transform: `scale(${fsize})`,
      transformOrigin: 'top left',
    },
  })
  let visibleCol = []

  if (moddata && Object.keys(moddata).length > 0) {
    visibleCol = moddata.pageData.filter((ele) => ele.Visible == 'true').map((itm) => itm.Parameter)
  }
  let data = []
  if (rptdata && rptdata?.length > 0)
    data = rptdata.filter((val, ind) => ind === 0) //


  //console.log(rptdata, moddata, data,currencysetting)

  let totalAmount = useMemo(
    () =>
      calculateTotal({
        data: rptdata,
        columnName: "Amount",
      }),
    [rptdata]
  )
  let totalAmountD = useMemo(
    () =>
      calculateTotal({
        data: rptdata,
        columnName: "AmountD",
      }),
    [rptdata]
  )

  let totalPcs = useMemo(
    () =>
      calculateTotal({
        data: rptdata,
        columnName: "Nos",
      }),
    [rptdata]
  )
  let totalWeight = useMemo(
    () =>
      calculateTotalWeight({
        data: rptdata,
        columnName: "Weight",
      }),
    [rptdata]
  )

  const renderMemoContent = () =>
  (

    data && data.length > 0 && data.map((item, index) => {
      return (
        <View key={index}>
          {/* // <View style={{...styles.section,width:'50%'}}>  */}
          {/* HEader */}
          <View style={[styles.table]}>
            <View style={[styles.tableRow,]}>
              <View style={[styles.tableCol, { minHeight: '55px', textAlign: "center", width: "100%" }]}>
                <Text style={[styles.tableCell, styles.Heading]}>{item?.CompName}</Text>
                <Text style={{ lineHeight: 0.8 }}>
                  {item?.Comp_Add1 +
                    " " +
                    item?.Comp_Add2 +
                    " " +
                    item?.Comp_Add3 +
                    " " +
                    item?.Comp_Add4 +
                    " " +
                    item?.Comp_City +
                    " " +
                    item?.Comp_State
                  }
                </Text>
                <Text>
                  {
                    "GSTIN:" + item?.Comp_GSTNo || ''
                  }
                  {item?.Comp_ContectNo1 ? '  (M) ' + item?.Comp_ContectNo1 || '' : "" +
                    "   " +
                    item?.Comp_ContectNo2 ? '  (O) ' + item?.Comp_ContectNo2 || '' : ""
                  }</Text>
              </View>
            </View>
          </View>
          <View style={[styles.table,
          { width: "100%", borderWidth: "1px", borderColor: "gray", backgroundColor: "#d9d9d9", textTransform: "uppercase", fontSize: "11px" }]}>
            <View style={[styles.tableRow]}>
              <View style={[styles.tableCol, styles.fontBold]}>
                <Text style={styles.tableCell}>
                  {data && data.length > 0 ? getBillType(data[0].Bill_Type) + ' ' +
                    getTradeOf(data[0].Trade_Of) + " Memo" + " ( " + getPktType(data[0].PktType) + " ) " : ""}
                </Text>
              </View>
            </View>
          </View>
          <View style={[styles.table]}>
            <View style={[styles.tableRow, styles.tableTopBorder]}>
              <View style={[styles.tableCol, styles.colWidth_lg]}>
                <View style={[styles.table, { width: "100%" }]}>
                  <View style={[styles.tableRow]}>
                    <View style={[styles.tableCol, styles.colWidth_label, { width: "40%" }]}>
                      <Text style={styles.tableCell}>Memo No.</Text>
                    </View>
                    <View style={[styles.tableCol, styles.colMid, { width: "10%" }]}>
                      <Text style={styles.tableCell}>:</Text>
                    </View>
                    <View style={[styles.tableCol, styles.colWidth]}>
                      <Text style={styles.tableCell}>{item.Vou_No}</Text>
                    </View>
                    <View style={[styles.tableCol, styles.colWidth_label]}>
                      <Text style={styles.tableCell}>Date</Text>
                    </View>
                    <View style={[styles.tableCol, styles.colMid, { width: "10%" }]}>
                      <Text style={styles.tableCell}>:</Text>
                    </View>
                    <View style={[styles.tableCol, styles.colWidth, {}]}>
                      <Text style={styles.tableCell}>{getDateFn(item?.Chal_Date)} </Text>
                    </View>
                  </View>
                </View>
                <View style={[styles.table, { width: "100%" }]}>
                  <View style={[styles.tableRow]}>

                    <View style={[styles.tableCol, styles.colWidth_label]}>
                      <Text style={styles.tableCell}>Party Name</Text>
                    </View>
                    <View style={[styles.tableCol, styles.colMid]}>
                      <Text style={styles.tableCell}>:</Text>
                    </View>
                    <View style={[styles.tableCol, styles.colWidth]}>
                      <Text style={styles.tableCell}>{item.PartyName}</Text>
                    </View>

                  </View>
                  <View style={[styles.tableRow]}>

                    <View style={[styles.tableCol, styles.colWidth_label]}>
                      <Text style={styles.tableCell}>
                        Broker</Text>
                    </View>
                    <View style={[styles.tableCol, styles.colMid]}>
                      <Text style={styles.tableCell}>:</Text>
                    </View>
                    <View style={[styles.tableCol, styles.colWidth]}>
                      <Text style={styles.tableCell}>{item.BrokerName}</Text>
                    </View>
                  </View>
                </View>
              </View>
            </View>
          </View>
          <View style={[styles.table, { borderTopWidth: "1px", borderBottomWidth: "1px", marginTop: "5px" }]}>
            <View style={[styles.tableRow, styles.font_bold, { borderBottom: "1px" }]}>
              <View style={[styles.tableColItem, styles.srno, styles.colBorder]}>
                <Text style={[styles.tableCellItem, styles.tableHeading]}>No.</Text>
              </View>
              <View style={[styles.tableColItem, styles.desc, styles.colBorder]}>
                <Text style={[styles.tableCellItem, styles.tableHeading]}>Particular</Text>
              </View>
              {/* <View style={[styles.tableColItem, styles.pkt, styles.colBorder]}>
                <Text style={[styles.tableCellItem, styles.tableHeading]}>Packets</Text>
              </View> */}
              <View style={[styles.tableColItem, styles.pcs, styles.colBorder]}>
                <Text style={[styles.tableCellItem, styles.tableHeading]}>Pcs</Text>
              </View>
              <View style={[styles.tableColItem, styles.weight, styles.colBorder]}>
                <Text style={[styles.tableCellItem, styles.tableHeading]}>Weight</Text>
              </View>

              {currencysetting != ENUM_CURRENCY_SETTING_VAL.RS ?
                <View style={[styles.tableColItem, styles.rate, styles.colBorder,]}>
                  <Text style={[styles.tableCellItem, styles.tableHeading]}>Rate($)</Text>
                </View>
                : ""}
              {currencysetting != ENUM_CURRENCY_SETTING_VAL.RS ?
                <View style={[styles.tableColItem, styles.amount, styles.colBorder,]}>
                  <Text style={[styles.tableCellItem, styles.tableHeading]}>Amount($)</Text>
                </View>
                : ""}
              {currencysetting != ENUM_CURRENCY_SETTING_VAL.Dollar ?
                <View style={[styles.tableColItem, styles.rate, styles.colBorder,]}>
                  <Text style={[styles.tableCellItem, styles.tableHeading]}>Rate</Text>
                </View>
                : ""}
              {currencysetting != ENUM_CURRENCY_SETTING_VAL.Dollar ?
                <View style={[styles.tableColItem, styles.amount, styles.colBorder,]}>
                  <Text style={[styles.tableCellItem, styles.tableHeading]}>Amount</Text>
                </View>
                : ""}
            </View>
          </View>
          {/* <View style={[styles.tableRow,]}> */}
          <View style={[styles.table]}>
            {rptdata.map((itemlist, ind) => (

              <View key={ind} style={[styles.tableRow, styles.font_bold, { borderBottom: "1px" }]}>
                <View style={[styles.tableColItem, styles.srno, styles.colBorder]}>
                  <Text style={[styles.tableCellItem]}>{++ind}</Text>
                </View>
                <View style={[styles.tableColItem, styles.desc, styles.colBorder]}>
                  <Text style={[styles.tableCellItem, { fontSize: "7px" }]}>
                    {getMemoParticular(visibleCol, itemlist, item?.PktType)}
                  </Text>
                  <Text>
                    {itemlist?.Item_Det}
                  </Text>
                  {/* // data && data.length > 0 ? getTradeOf(data[0].Trade_Of) : "" */}
                </View>
                {/* <View style={[styles.tableColItem, styles.pkt, styles.colBorder]}>
                  <Text style={[styles.tableCellItem]}>{
                    // { i }
                    // rptdata && rptdata?.length > 0 ? rptdata.length : 0
                  }</Text>
                </View> */}
                <View style={[styles.tableColItem, styles.pcs, styles.colBorder,]}>
                  <Text style={[styles.tableCellItem]}>
                    {itemlist.Nos}
                  </Text>
                </View>
                <View style={[styles.tableColItem, styles.weight, styles.colBorder,]}>
                  <Text style={[styles.tableCellItem]}>
                    {itemlist.Weight.toFixed(2)}
                  </Text>
                </View>
                {currencysetting != ENUM_CURRENCY_SETTING_VAL.RS ?
                  <View style={[styles.tableColItem, styles.rate, styles.colBorder,]}>
                    <Text style={[styles.tableCellItem]}>
                      {itemlist.S_Rate.toFixed(2)}
                    </Text>
                  </View>
                  : ""}
                {currencysetting != ENUM_CURRENCY_SETTING_VAL.RS ?
                  <View style={[styles.tableColItem, styles.amount, styles.colBorder,]}>
                    <Text style={[styles.tableCellItem]}>
                      {itemlist.AmountD.toFixed(2)}
                    </Text>
                  </View>
                  : ""}
                {currencysetting != ENUM_CURRENCY_SETTING_VAL.Dollar ?
                  <View style={[styles.tableColItem, styles.rate, styles.colBorder,]}>
                    <Text style={[styles.tableCellItem]}>
                      {itemlist.Rate.toFixed(2)}
                    </Text>
                  </View>
                  : ""}
                {currencysetting != ENUM_CURRENCY_SETTING_VAL.Dollar ?
                  <View style={[styles.tableColItem, styles.amount, styles.colBorder,]}>
                    <Text style={[styles.tableCellItem]}>
                      {itemlist.Amount.toFixed(2)}
                    </Text>
                  </View>
                  : ""}

              </View>
            ))}

          </View>
          <View style={[styles.table]}>
            <View style={[styles.tableRow, styles.fontBold, styles.tableTopBorder, { marginTop: "1px" }]}>
              <View style={[styles.tableColItem, styles.srno, styles.colBorder]}>
                <Text style={[styles.tableCellItem]}></Text>
              </View>
              <View style={[styles.tableColItem, styles.desc, styles.colBorder]}>
                <Text style={[styles.tableCellItem]}>Total</Text>
              </View>
              {/* <View style={[styles.tableColItem, styles.pkt, styles.colBorder]}>
                <Text style={[styles.tableCellItem]}>{rptdata && rptdata?.length > 0 ? rptdata.length : 0}</Text>
              </View> */}
              <View style={[styles.tableColItem, styles.pcs, styles.colBorder,]}>
                <Text style={[styles.tableCellItem]}>{totalPcs}</Text>
              </View>
              <View style={[styles.tableColItem, styles.weight, styles.colBorder,]}>
                <Text style={[styles.tableCellItem]}>{totalWeight}</Text>
              </View>

              {currencysetting != ENUM_CURRENCY_SETTING_VAL.RS ?
                <View style={[styles.tableColItem, styles.rate, styles.colBorder,]}>
                  <Text style={[styles.tableCellItem]}></Text>
                </View>
                : ""}
              {currencysetting != ENUM_CURRENCY_SETTING_VAL.RS ?
                <View style={[styles.tableColItem, styles.amount, styles.colBorder,]}>
                  <Text style={[styles.tableCellItem]}>{totalAmountD}</Text>
                </View>
                : ""}
              {currencysetting != ENUM_CURRENCY_SETTING_VAL.Dollar ?
                <View style={[styles.tableColItem, styles.rate, styles.colBorder,]}>
                  <Text style={[styles.tableCellItem]}></Text>
                </View>
                : ""}
              {currencysetting != ENUM_CURRENCY_SETTING_VAL.Dollar ?
                <View style={[styles.tableColItem, styles.amount, styles.colBorder,]}>
                  <Text style={[styles.tableCellItem]}>{totalAmount}</Text>
                </View>
                : ""}
            </View>
          </View>
          <View style={[styles.table,]}>
            <View style={[styles.tableRow, styles.tableTopBorder, { marginTop: "1px", borderBottom: "1", }]}>
              <View style={[styles.tableColItem, styles.colBorder, { borderRight: "1", width: "50%", padding: "0px" }]}>
                <Text style={{ lineHeight: 2, paddingTop: "2px", borderBottom: "1", borderColor: "#000000", width: "100%" }}>  </Text>
                <Text style={[styles.tableCellItem, styles.fontBold, { padding: "5px", fontSize: "8px" }]}>
                  Received Signatory</Text>
                {/* <Text style={{ paddingTop: "20px", borderBottom: "1", width: "100%" }}></Text>
                <Text style={[styles.tableCellItem, styles.fontBold, { padding: "4px", fontSize: "8px" }]}>
                  <Text style={{ paddingLeft: "5px" }}>Received Signatory</Text></Text> */}
              </View>
              <View style={[styles.tableColItem, styles.fontBold, styles.colBorder, { width: "50%", padding: "0px" }]}>
                <Text style={{ lineHeight: 2, paddingTop: "2px", borderBottom: "1", borderColor: "#000000", width: "100%" }}> For : {item?.CompName} </Text>
                <Text style={[styles.tableCellItem, { padding: "5px", fontSize: "8px" }]}>
                  Authorised Signatory</Text>
              </View>

            </View>
            <View style={[styles.tableRow, styles.tableTopBorder, { marginTop: "1px", borderBottom: "1", }]}>
              {t_termsCondition && t_termsCondition != ""  && t_termsCondition !=null?
                <View style={[styles.tableColItem, styles.colBorder, { lineHeight: 1.3, fontSize: "8px", padding: "2px", width: "100%", textAlign: "left" }]}>
                  <Text style={[styles.tableCellItem, styles.fontBold, { paddingBottom: "2px" }]}>Terms & Condition</Text>
                  {
                    t_termsCondition.includes("<br/>")
                      ? t_termsCondition.split("<br/>").map((line, index) => (
                        <Text
                          key={index}
                          style={{
                            marginLeft: 10,     // space for wrapped lines
                            textIndent: -10,    // pulls number to the left
                            marginBottom: 2,
                          }}
                        >
                          {index + 1}. {line}
                        </Text>
                      ))
                      : <Text>{t_termsCondition}</Text>
                  }
                </View>
                : <View style={[styles.tableColItem, styles.colBorder, { lineHeight: 1.3, fontSize: "8px", padding: "2px", width: "100%", textAlign: "left" }]}>
                  <Text style={[styles.tableCellItem, styles.fontBold, { paddingBottom: "2px" }]}>Terms & Condition</Text>
                  <Text>1.The goods have been entrusted to me solely for the purpose of being shown to intending purchasers for inspection.</Text>

                  <Text>2.The goods remain your property, and I acquire no right, title, or interest in them until a sale note signed by you is issued or until the price is paid in full, notwithstanding the fact that the rate or price is mentioned in the particulars of the goods set forth herein.</Text>

                  <Text>3.I agree not to sell, pledge, mortgage, or hypothecate the said goods, or otherwise deal with them in any manner, until a sale note signed by you is issued or the price is paid to you.</Text>

                  <Text>4.The goods are to be returned to you immediately upon demand.</Text>

                  <Text>5.The goods will be at my risk in all respects until a sale note signed by you is issued or until the price is paid to you, or until the goods are returned to you. I am responsible for returning the said goods to you in the same condition in which I received them.</Text>
                </View>
              }
              {/* <View style={[styles.tableColItem, styles.colBorder, {lineHeight:1.3, fontSize: "8px", padding: "2px", width: "100%",  textAlign: "left" }]}>
                <Text style={[styles.tableCellItem,styles.fontBold, {paddingBottom:"2px"}]}>Terms & Condition</Text>
                
                <Text>1.The goods have been entrusted to me solely for the purpose of being shown to intending purchasers for inspection.</Text>

                <Text>2.The goods remain your property, and I acquire no right, title, or interest in them until a sale note signed by you is issued or until the price is paid in full, notwithstanding the fact that the rate or price is mentioned in the particulars of the goods set forth herein.</Text>

                <Text>3.I agree not to sell, pledge, mortgage, or hypothecate the said goods, or otherwise deal with them in any manner, until a sale note signed by you is issued or the price is paid to you.</Text>

                <Text>4.The goods are to be returned to you immediately upon demand.</Text>

                <Text>5.The goods will be at my risk in all respects until a sale note signed by you is issued or until the price is paid to you, or until the goods are returned to you. I am responsible for returning the said goods to you in the same condition in which I received them.</Text>
              </View> */}

            </View>

          </View>

        </View>

      )
    })
  )

  return (
    <Document pageMode="fullScreen">
      <Page size="A4" orientation="landscape">
        {rptdata && rptdata?.length > 0 ?
          <View style={[styles.scaledContent]}>
            <View style={{ ...styles.section, flexDirection: 'row' }}>
              <View style={{ width: '50%', border: '1', marginRight: '1' }}>
                {renderMemoContent()}
              </View>
              <View style={{ width: '50%', border: '1' }}>
                {renderMemoContent()}
              </View>
            </View> </View> : ""}
      </Page>
      {/* <Page size="A4" style={styles.page}>
        {data && data.map((item, index) => {
          return (
            <>

            </>
          )
        })}
      </Page> */}
    </Document>
  )
}
export default RptMemo
